module.exports = __webpack_public_path__ + "static/mobile-landing-video-editor-98bae95fce153a5537709ef24e59028f.svg";